module.exports = __webpack_public_path__ + "static/media/logo-mediasoft.ec44707b.svg";